<app-page-header Heading="Whatsapp Template " class="text-primary">

  <div class=" mb-0">
    <div class="card-body px-1 py-0">
      <div class="d-flex align-items-center gap-3 filter-row w-100" id="filterContainer">
        <!-- <app-pagination [EnablePageSize]="true" [rowData]="emailConfigList"
                (pageSizeChanged)="handlePageSizeChange($event)">
            </app-pagination> -->

        <!-- Push this entire group to the right -->
        <div class="d-flex align-items-center gap-2 ms-auto pb-0 mt-0">

          <!-- 🔽 Whatsapp Config Dropdown -->
          <select class="form-select form-select-sm" style="width: 260px;  " [(ngModel)]="selectedWaConfigId"
            (ngModelChange)="onWhatsappConfigChange($event)" [ngModelOptions]="{ standalone: true }">
            <option [ngValue]="0" disabled>Select Whatsapp Config</option>
            <option *ngFor="let c of whatsappConfigList" [ngValue]="c.waConfigId">
              {{ c.iName }}
            </option>
          </select>

          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item" *ngFor="let tab of tabs" [ngbTooltip]="tab.tabName">
              <a #tabLink class="nav-link" [ngClass]="this.selectedTab == tab.tabName ? '' : ''"
                [attr.id]="tab.tabName+'-tab'" data-bs-toggle="tab" [attr.data-bs-target]="'#' + tab.tabName"
                type="button" role="tab" [attr.aria-controls]="tab.tabName"
                [attr.aria-selected]="this.selectedTab === tab.tabName" (click)="onTabSelect(tab.tabName)">

                <i class="{{tab.tabIcon}}"></i>
              </a>
            </li>
          </ul>
        </div>

        <div class="btn btn-primary btn-sm custom-btn top-2" (click)="openwhatsappTemplateForm()">
          Add new Whatsapp Template
        </div>
      </div>
    </div>
  </div>
</app-page-header>

<!-- Push this entire group to the right
  <div class="d-flex align-items-end gap-2 ms-auto pb-1">
        <ul class="nav nav-tabs" id="myTab" role="tablist">
          <li class="nav-item" *ngFor="let tab of tabs" [ngbTooltip]="tab.tabName">
            <a #tabLink class="nav-link" [ngClass]="this.selectedTab == tab.tabName ? 'active' : ''"
              [attr.id]="tab.tabName+'-tab'" data-bs-toggle="tab" [attr.data-bs-target]="'#' + tab.tabName"
              type="button" role="tab" [attr.aria-controls]="tab.tabName"
              [attr.aria-selected]="this.selectedTab === tab.tabName" (click)="onTabSelect(tab.tabName)">
              <i class="{{tab.tabIcon}}"></i>
            </a>
          </li>
        </ul>


      </div> -->

<div *ngIf="isLoading" class="text-center my-4">
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
  <div style="margin-top:8px;color:#4251C8;">Loading templates...</div>
</div>

<div [ngSwitch]="selectedTab">

  <!-- ================= TABULAR VIEW ================= -->
  <div *ngSwitchCase="'Tabular'">
    <app-color-table [columns]="[
        { colName: 'Template Name', colData: 'name' },
        { colName: 'Status', colData: 'status' },
        { colName: 'Language', colData: 'language' },
        { colName: 'ParameterFormat', colData: 'parameterFormat' },
        { colName: 'Category', colData: 'category' }
      ]" [tableData]="whatsappTemplateList" [enableActionColumn]="true" [actionColumnLabel]="'Action'" [actionOptions]="[
        { actionName: 'Edit', actionIcon: 'fa fa-edit' },
        { actionName: 'Delete', actionIcon: 'fa fa-trash' }
      ]" (actionClick)="handleActionClick($event)" [DataLoading]="isLoading">
    </app-color-table>
  </div>
  <!-- ================= GRID VIEW ================= -->

  <div *ngSwitchCase="'Grid'" class="row g-2">

    <div class="col-md-6 col-lg-5-custom mb-2 p-2" *ngFor="let whatsappTemplate of whatsappTemplateList ">



      <!-- Card wrapper -->
      <div class="card shadow-sm rounded-4 position-relative whatsapp-template-card" style="background-image: url('/assets/images/whatsapp.jpeg');
            background-size: cover;
            background-repeat: no-repeat;
            border-top-left-radius: px;
            border-top-right-radius: px;
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
            overflow: hidden;" *ngIf=" whatsappTemplateList.length > 0">



        <!-- FIXED → MENU HERE, DIRECT CHILD OF CARD -->
        <div class="card-menu dropdown">
          <button class="btn btn-sm p-1 border-0 bg-transparent position-absolute top-0 end-0 m-3 fs-5" type="button"
            data-bs-toggle="dropdown">
            <i class="fa-solid fa-ellipsis-vertical"></i>
          </button>

          <ul class="dropdown-menu dropdown-menu-end">
            <li>
              <a class="dropdown-item" (click)="editTemplate(whatsappTemplate)">
                <i class="fa fa-edit me-2 text-primary"></i> Edit
              </a>
            </li>
            <li>
              <a class="dropdown-item text-danger" (click)="deleteTemplate(whatsappTemplate)">
                <i class="fa fa-trash me-2"></i> Delete
              </a>
            </li>
          </ul>
        </div>

        <!-- CONTENT -->

        <div class="p-2">
          <div class="bg-white p-2 flex-grow-1 mb-0 whatsapp-bubble" style="height: 200px; 
            
            border-top-right-radius: 15px;
            border-bottom-left-radius: 15px;
            border-bottom-right-radius: 15px; display: flex; flex-direction: column; justify-content: space-between;">


            <!-- Top content pushed slightly down -->
            <div style="margin-top: 10px;">
              <!-- <div class="fw-bold mb-1">{{ whatsappTemplate.name }}</div> -->
              <div class="ellipsis-text mb-3" [ngbTooltip]="getBodyText(whatsappTemplate)" container="body">
                {{ getBodyText(whatsappTemplate) }}
              </div>
            </div>

            <div class="d-flex justify-content-between">
              <span class="wt-badge-category">{{ whatsappTemplate.category }}</span>
              <span class="wt-badge-language">{{ whatsappTemplate.language }}</span>
            </div>

          </div>
        </div>


        <!-- VIEW BUTTON -->
        <!-- FOOTER ACTION BAR -->
        <div class="border-top bg-white rounded-bottom-4 px-3 py-2
            d-flex justify-content-between align-items-center mt-auto" style="margin-top: 20px;">

          <span class="fw-normal text-truncate" style="max-width: 65%; font-size: 14px; color: #4B5563;">
            <span class="template-name">
              {{ whatsappTemplate.name }}
            </span>
          </span>

          <div class="dropdown" data-bs-display="static" data-bs-auto-close="outside" data-bs-reference="parent"
            style="position: static;">

            <button class="btn btn-sm"
              style="background: #F2F4FF; color: #2c2c2a; border-radius: 0px; padding: 6px 14px; font-weight: 500;"
              data-bs-toggle="dropdown" type="button" (click)="selectedTestTemplate = whatsappTemplate">
              Send Test
            </button>

            <div class="dropdown-menu p-3 shadow" style="min-width: 260px; top: 100%; right: 0;">

              <label class="form-label" style="font-size: 13px;">Phone No</label>
              <input type="text" class="form-control form-control-sm" placeholder="Enter phone number"
                [(ngModel)]="testPhoneNumber" [ngModelOptions]="{ standalone: true }" />

              <label class="form-label mt-2" style="font-size: 13px;">Variable values in order (separate with |)</label>
              <input type="text" class="form-control form-control-sm" placeholder="e.g. Rahul|INV-1001|10-Oct"
                [(ngModel)]="testValues" [ngModelOptions]="{ standalone: true }" />

              <div class="d-grid mt-2">
                <button class="btn btn-success btn-sm" (click)="sendTestMessage(selectedTestTemplate)">
                  Send
                </button>
              </div>

            </div>

          </div>



        </div>



      </div>
    </div>
    <div *ngIf="whatsappTemplateList.length === 0 && !isLoading"
      class="d-flex flex-column align-items-center justify-content-center py-5 w-100">
      <img src="assets/images/no-data-found.svg" alt="No Data Found" style="width: 200px; opacity: 0.85;">
      <p class="text-muted mt-3 mb-0 fw-semibold" style="font-size: 1rem;">No WhatsApp Templates Found</p>
      <p class="text-muted small">No templates available for the selected configuration. Add a new template to get started.</p>
    </div>
  </div>


  <!-- MODAL -->
  <ng-template #whatsappTemplateModalForm>
    <div class="wt-modal-root">
      <div class="wt-scroll-area">

        <!-- HEADER -->
        <div class="wt-modal-header-bar">
          <h2>{{ whatsappTemplateForm.get('templateId')?.value ? 'Edit Template' : 'Create New Template' }}</h2>
          <button class="wt-close-header" (click)="addwhatsappTemplateModalContent.close()">×</button>
        </div>

        <div class="wt-modal-body">
          <form [formGroup]="whatsappTemplateForm" class="wt-form" (ngSubmit)="submitwhatsappTemplateForm()">

            <!-- SECTION 1 -->
            <section class="wt-card">
              <div class="wt-card-head">
                <h4 style="color:#4251C8;">Template Name & Language</h4>
              </div>

              <div class="wt-row no-wrap">

                <!-- Template Name -->
                <div class="wt-col col-template">
                  <label class="wt-label">Template Name</label>
                  <input type="text" class="wt-input" formControlName="tName" placeholder="e.g. order_update_2025" />
                  <app-form-errors [control]="whatsappTemplateForm.controls.tName" fieldName="Template Name"></app-form-errors>

                  <div *ngIf="whatsappTemplateForm.get('tName')?.touched && whatsappTemplateForm.get('tName')?.invalid"
                    style="color:#d9534f;margin-top:6px;font-size:13px;">
                    <div *ngIf="whatsappTemplateForm.get('tName')?.errors?.['required']">Template name is
                      required.</div>
                    <div *ngIf="whatsappTemplateForm.get('tName')?.errors?.['pattern']">Only lowercase letters,
                      numbers
                      and _ are allowed.</div>
                  </div>

                  <small style="display:block;margin-top:8px;color:#666">Example:
                    <code>order_update_2025</code></small>
                </div>

                <!-- LANGUAGE DROPDOWN -->
                <div class="wt-col col-language">
                  <label class="wt-label" style="margin-bottom:8px;">Select Language</label>

                  <div class="wt-dropdown" style="position:relative;width:230px;">

                    <button class="btn btn-light dropdown-toggle" type="button" (click)="toggleDropdown($event)"
                      style="width:100%;text-align:left;border:1px solid #ddd;padding:8px 12px;background:#ffffff;">
                      {{ whatsappTemplateForm.get('language')?.value || 'Select language' }}
                    </button>

                    <ul class="wt-dropdown-menu wt-dropdown-select" style="max-height:220px;overflow:auto;">
                      <li
                        (click)="whatsappTemplateForm.get('language')?.setValue('en_US'); $event.stopPropagation(); closeAllDropdowns()">
                        English (US) — en_US</li>
                      <li
                        (click)="whatsappTemplateForm.get('language')?.setValue('en_GB'); $event.stopPropagation(); closeAllDropdowns()">
                        English (GB) — en_GB</li>
                      <li
                        (click)="whatsappTemplateForm.get('language')?.setValue('hi_IN'); $event.stopPropagation(); closeAllDropdowns()">
                        Hindi — hi_IN</li>
                      <li
                        (click)="whatsappTemplateForm.get('language')?.setValue('mr_IN'); $event.stopPropagation(); closeAllDropdowns()">
                        Marathi — mr_IN</li>
                      <li
                        (click)="whatsappTemplateForm.get('language')?.setValue('es_ES'); $event.stopPropagation(); closeAllDropdowns()">
                        Spanish — es_ES</li>
                      <li
                        (click)="whatsappTemplateForm.get('language')?.setValue('fr_FR'); $event.stopPropagation(); closeAllDropdowns()">
                        French — fr_FR</li>
                    </ul>

                  </div>
                  <app-form-errors [control]="whatsappTemplateForm.controls.language" fieldName="Language"></app-form-errors>
                </div>

                <!-- Category -->
                <div class="wt-col col-category" style="display:flex;flex-direction:column;justify-content:flex-end;">
                  <label class="wt-label">Detected Category</label>
                  <div
                    style="padding:8px 12px;border:1px solid #e5e5e5;border-radius:0px;background:#fafafa;min-height:38px;">
                    <strong>{{ detectedCategory || 'MARKETING' }}</strong>
                    <div style="font-size:12px;color:#666;margin-top:6px;">Auto-detected from body</div>
                  </div>

                  <div style="margin-top:8px;">
                    <select class="wt-input" [value]="detectedCategory"
                      (change)="whatsappTemplateForm.get('category')?.setValue($any($event.target).value)">
                      <option value="AUTHENTICATION">AUTHENTICATION</option>
                      <option value="UTILITY">UTILITY</option>
                      <option value="MARKETING">MARKETING</option>
                    </select>
                  </div>
                </div>

              </div>
            </section>

            <!-- SECTION 2 -->
            <section class="wt-card">
              <div class="wt-card-head">
                <h4 style="color:#4251C8;">Content</h4>
              </div>

              <div class="wt-row wt-row-gap">

                <!-- Header Type -->
                <div class="wt-col wt-col-2">
                  <label class="wt-label" style="margin-bottom:8px;">Header Type</label>

                  <div class="wt-dropdown" style="position:relative;">

                    <button class="btn btn-light dropdown-toggle" type="button" (click)="toggleDropdown($event)"
                      style="width:180px;text-align:left;border:1px solid #ddd;padding:8px 12px;background:#ffffff;">
                      {{ whatsappTemplateForm.get('headerType')?.value || 'Text' }}
                    </button>

                    <ul class="wt-dropdown-menu">
                      <li
                        (click)="whatsappTemplateForm.get('headerType')?.setValue('TEXT'); $event.stopPropagation(); closeAllDropdowns()">
                        Text</li>
                      <li
                        (click)="whatsappTemplateForm.get('headerType')?.setValue('IMAGE'); $event.stopPropagation(); closeAllDropdowns()">
                        Image</li>
                      <li
                        (click)="whatsappTemplateForm.get('headerType')?.setValue('VIDEO'); $event.stopPropagation(); closeAllDropdowns()">
                        Video</li>
                      <li
                        (click)="whatsappTemplateForm.get('headerType')?.setValue('NONE'); $event.stopPropagation(); closeAllDropdowns()">
                        None</li>
                    </ul>

                  </div>
                </div>

                <!-- Header Text -->
                <div class="wt-col wt-col-10">
                  <label class="wt-label">Header</label>
                  <input type="text" class="wt-input" formControlName="otherDetail1" placeholder="Header text here" />
                </div>

              </div>

              <!-- Template Variable -->
              <div class="wt-row">
                <div class="wt-col wt-col-12">
                  <label class="wt-label">Template Variable</label>
                  <input type="text" class="wt-input" formControlName="templateVariable" readonly
                    placeholder="Auto-filled from body (e.g. {{1}}, {{2}})" />
                  <app-form-errors [control]="whatsappTemplateForm.controls.templateVariable" fieldName="Template Variable"></app-form-errors>
                </div>
              </div>

              <!-- Body -->
              <div class="wt-row">
                <div class="wt-col wt-col-12">
                  <label class="wt-label">Body</label>

                  <div class="wt-toolbar">
                    <button type="button" class="wt-toolbtn">😊</button>
                    <button type="button" class="wt-toolbtn"><b>B</b></button>
                    <button type="button" class="wt-toolbtn"><i>I</i></button>
                    <button type="button" class="wt-toolbtn">{{ '{}' }}</button>
                    <button type="button" class="wt-toolbtn">+ Variable</button>
                  </div>

                  <textarea class="wt-textarea" rows="6" formControlName="templateData"
                    (input)="onBodyInput()"></textarea>
                  <app-form-errors [control]="whatsappTemplateForm.controls.templateData" fieldName="Body"></app-form-errors>

                  <div
                    *ngIf="whatsappTemplateForm.get('templateData')?.touched && whatsappTemplateForm.get('templateData')?.errors?.['required']"
                    style="color:#d9534f; margin-top:6px; font-size:13px;">
                    Body is required.
                  </div>

                  <div *ngIf="placeholderError" style="color:#d9534f; margin-top:6px; font-size:13px;">
                    {{ placeholderError }}
                  </div>

                </div>
              </div>

              <div class="wt-row">
                <div class="wt-col wt-col-12">
                  <input type="text" class="wt-input" formControlName="tDesc" placeholder="e.g. Footer" />
                </div>
              </div>

            </section>

            <!-- SECTION 3: Buttons -->
            <!-- SECTION 3: Buttons -->
            <section class="wt-card">

              <div class="wt-card-head">
                <div style="display:flex;justify-content:space-between;align-items:center;width:100%;">
                  <h4 style="color:#4251C8;margin:0;font-size:20px;font-weight:600;">Buttons</h4>

                  <!-- Add Button -->
                  <div class="wt-dropdown" style="position: relative; width: 160px;">
                    <button class="btn btn-light dropdown-toggle" type="button" (click)="toggleDropdown($event)" style="width: 100%;text-align: left;border: 1px solid #ddd;
                padding: 8px 12px;background:#4251C8;color: #fff;font-weight: 500;border-radius: 0px;">
                      + Add Button
                    </button>

                    <ul class="wt-dropdown-menu" style="width: 160px;">
                      <li (click)="addButton('Custom'); $event.stopPropagation(); closeAllDropdowns()">Quick Reply
                      </li>
                      <li (click)="addButton('Visit Website'); $event.stopPropagation(); closeAllDropdowns()">
                        Visit
                        Website</li>
                      <li (click)="addButton('Call Phone Number'); $event.stopPropagation(); closeAllDropdowns()">
                        Call
                        Phone Number</li>
                    </ul>
                  </div>

                </div>
              </div>

              <div class="wt-p-16" formArrayName="buttons" style="border:none !important;">

                <div *ngFor="let btn of buttons.controls; let i = index" [formGroupName]="i" class="wt-row"
                  style="align-items:center; margin-bottom:15px; gap:14px !important;">

                  <!-- Action Type -->
                  <div class="wt-col" style="width: 14%;">
                    <label class="wt-label small">Action Type</label>

                    <div class="wt-dropdown" style="position:relative;width:100%;">
                      <button class="btn btn-light dropdown-toggle" type="button" (click)="toggleDropdown($event)"
                        style="width:100%;text-align:left;border:1px solid #ddd;padding:8px 12px;background:#ffffff;">
                        {{ btn.get('actionType')?.value }}
                      </button>

                      <ul class="wt-dropdown-menu">
                        <li
                          (click)="btn.get('actionType')?.setValue('Custom'); $event.stopPropagation(); closeAllDropdowns()">
                          Quick Reply</li>
                        <li
                          (click)="btn.get('actionType')?.setValue('Visit Website'); $event.stopPropagation(); closeAllDropdowns()">
                          Visit Website</li>
                        <li
                          (click)="btn.get('actionType')?.setValue('Call Phone Number'); $event.stopPropagation(); closeAllDropdowns()">
                          Call Phone Number</li>
                      </ul>
                    </div>
                  </div>

                  <!-- Button Text -->
                  <div class="wt-col" style="width: 28%;">
                    <label class="wt-label small">Button Text</label>
                    <input type="text" class="wt-input" formControlName="buttonText" placeholder="Learn More" />
                  </div>

                  <!-- URL Type (SHOW ONLY for Visit Website) -->
                  <div class="wt-col" style="width: 14%;" *ngIf="isUrlButton(btn)">
                    <label class="wt-label small">URL Type</label>

                    <div class="wt-dropdown" style="position:relative;width:100%;">
                      <button class="btn btn-light dropdown-toggle" type="button" (click)="toggleDropdown($event)"
                        style="width:100%;text-align:left;border:1px solid #ddd;padding:8px 12px;background:#ffffff;">
                        {{ btn.get('urlType')?.value }}
                      </button>

                      <ul class="wt-dropdown-menu">
                        <li
                          (click)="btn.get('urlType')?.setValue('Static'); $event.stopPropagation(); closeAllDropdowns()">
                          Static</li>
                        <li
                          (click)="btn.get('urlType')?.setValue('Dynamic'); $event.stopPropagation(); closeAllDropdowns()">
                          Dynamic</li>
                      </ul>
                    </div>
                  </div>

                  <!-- Website URL (Visit Website) -->
                  <div class="wt-col" style="width: 32%;" *ngIf="isUrlButton(btn)">
                    <label class="wt-label small">Website URL</label>
                    <input type="text" class="wt-input" formControlName="websiteUrl"
                      placeholder="https://example.com" />
                    <app-form-errors [control]="btn.get('websiteUrl')" fieldName="Website URL"></app-form-errors>

                    <!-- Validation -->
                    <div *ngIf="btn.get('websiteUrl')?.errors?.['invalidUrl']"
                      style="color:#d9534f;font-size:12px;margin-top:4px;">
                      Enter a valid URL (must start with http:// or https://)
                    </div>
                  </div>

                  <!-- Phone Number (Call Phone Number) -->
                  <div class="wt-col" style="width: 32%;" *ngIf="isCallButton(btn)">
                    <label class="wt-label small">Phone Number (tel:+91…)</label>
                    <input type="text" class="wt-input" formControlName="websiteUrl" placeholder="tel:+919876543210" />
                    <app-form-errors [control]="btn.get('websiteUrl')" fieldName="Phone Number"></app-form-errors>

                    <!-- Validation -->
                    <div *ngIf="btn.get('websiteUrl')?.errors?.['invalidPhone']"
                      style="color:#d9534f;font-size:12px;margin-top:4px;">
                      Phone number must be in format: tel:+91XXXXXXXXXX
                    </div>
                  </div>

                  <!-- Quick Reply (No URL required) -->
                  <div class="wt-col" style="width:32%;" *ngIf="isQuickReply(btn)">
                    <label class="wt-label small" style="opacity:0;">X</label>
                    <p style="margin:0;color:#888;font-size:13px;">No URL required for Quick Reply</p>
                  </div>

                  <!-- Delete Button -->
                  <div class="wt-col"
                    style="width: 6%;display:flex;justify-content:center;align-items:center;margin-top:22px;">
                    <button class="wt-btn-icon" (click)="deleteButton(i)"
                      style="background:#fff; border:1px solid #ddd; color:red; padding:4px 8px;">
                      <i class="fa-solid fa-trash"></i>
                    </button>
                  </div>

                </div>
              </div>

            </section>


          </form>
        </div>

        <!-- FOOTER -->
        <div class="wt-modal-footer">
          <button type="button" class="wt-btn wt-btn-primary" (click)="submitwhatsappTemplateForm()">Submit</button>
          <button type="button" class="wt-btn wt-btn-secondary"
            (click)="addwhatsappTemplateModalContent.close()">Close</button>
        </div>

      </div>
    </div>
  </ng-template>